let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bLcEa")).then(() => parcelRequire('1HjYz'));